import ability from './ability'

export const canNavigate = to => to.matched.some(route => route.meta.action ? ability.can(route.meta.action) : true)
// export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action))

export const _ = undefined
